
export enum Industry {
    Healthcare,
    EducationalProvider,
    EmergencyMedicalService,
    GovFederalAndMilitary,
    Other,
    Distributor,
    PersonAccount
}